import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Ferie } from "../core/model/ferie";
import { FerieService } from "../core/service/ferie.service";
import { EditFerierComponent } from "./edit-ferier/edit-ferier.component";
import { AddFerierComponent } from "./add-ferier/add-ferier.component";

@Component({
  selector: "app-ferier",
  templateUrl: "./ferier.component.html",
  styleUrls: ["./ferier.component.scss"],
})
export class FerierComponent {
  feries: Ferie[];

  constructor(
    private modalService: NgbModal,
    private _ferieService: FerieService
  ) {}

  ngOnInit() {
    this.getFeries();
  }

  getFeries() {
    this._ferieService.getAllFeries().subscribe(
      (data) => {
        this.feries = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(ferie: Ferie): void {
    const modalRef = this.modalService.open(EditFerierComponent, {
      centered: true,
    });
    modalRef.componentInstance.ferie = ferie;

    modalRef.result.then(
      (updated: Ferie) => {
        if (updated && this.feries) {
          const index = this.feries.findIndex((f) => f.id === updated.id);
          if (index !== -1) {
            this.feries[index] = updated;
            this.feries = [...this.feries];
            return;
          }
        }
        this.getFeries();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddFerierComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getFeries();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
